import {getPreference} from '@netx/core-user-next/utils/getPreference';

export const pdfLaunchStandard = () =>
	getPreference('pdf.launchStandard', true);
